import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { markPaid, blockBasicForever } from '../utils/payments';
import api from '../api';
import './WaveSaleslandingpage/css/style.css';
import './WaveSaleslandingpage/css/aos.css';

const PLAN_BASIC_ID = 'P-03J1317075416911FNEKRCRY';
const PLAN_TRIM_ID  = 'P-2CM29653GH113435GNEKREIY';
const PLAN_ANUAL_ID = 'P-0FP40889RB1361443NEKRFEI';

const CID_BASIC = 'paypal-button-container-P-03J1317075416911FNEKRCRY';
const CID_TRIM  = 'paypal-button-container-P-2CM29653GH113435GNEKREIY';
const CID_ANUAL = 'paypal-button-container-P-0FP40889RB1361443NEKRFEI';

const paypalClientId = 'AaHXxh5YE1oofKVdmPtmiyTNSW1Xw-OmFUTHGM6bleuH1gIaXoWuxB1ApI62tAOdJDB03H4SPZUtJdWs';

export default function Renovacion() {
  const navigate = useNavigate();
  const paypalLoadedRef = useRef(false);
  const [code, setCode] = useState('');
  const [codeValid, setCodeValid] = useState(false);

  const [statusB, setStatusB] = useState('idle');
  const [errB, setErrB] = useState('');
  const [statusT, setStatusT] = useState('idle');
  const [errT, setErrT] = useState('');
  const [statusA, setStatusA] = useState('idle');
  const [errA, setErrA] = useState('');
  const [userName, setUserName] = useState('');

  const applyCode = (e) => {
    e?.preventDefault?.();
    setCodeValid(code.trim().toUpperCase() === 'VUELVE10');
  };

  const renderPaypalButton = (containerId, planId, setStatus, setError, planKey) => {
    try {
      if (!window.paypal) return;
      const container = document.getElementById(containerId);
      if (!container) return;
      if (container.hasChildNodes()) return; // evitar doble render
      setStatus('loading');
      window.paypal.Buttons({
        style: { shape: 'rect', color: 'gold', layout: 'vertical', label: 'subscribe' },
        createSubscription: (data, actions) => {
          setStatus('approving');
          return actions.subscription.create({ plan_id: planId });
        },
        onApprove: (data) => {
          setStatus('approved');
          try {
            markPaid('paypal', planKey, data?.subscriptionID);
            navigate('/configuracion');
          } catch (_) {
            alert('Suscripción creada: ' + data.subscriptionID);
          }
        },
        onError: (err) => {
          console.error('[PayPal] error', err);
          setError(String(err?.message || 'Error desconocido'));
          setStatus('error');
        },
        onCancel: () => {
          setError('Proceso cancelado por el usuario');
          setStatus('error');
        }
      }).render(`#${containerId}`).then(() => setStatus('rendered')).catch((e) => {
        console.error('[PayPal] render catch', e);
        setError(String(e?.message || 'Fallo al renderizar botón'));
        setStatus('error');
      });
    } catch (e) {
      console.error('[PayPal] excepción', e);
      setError(String(e?.message || 'Excepción inesperada'));
      setStatus('error');
    }
  };

  const loadAndRender = () => {
    if (!codeValid) return;
    renderPaypalButton(CID_BASIC, PLAN_BASIC_ID, setStatusB, setErrB, 'basic');
    renderPaypalButton(CID_TRIM,  PLAN_TRIM_ID,  setStatusT, setErrT, 'trimestral');
    renderPaypalButton(CID_ANUAL, PLAN_ANUAL_ID, setStatusA, setErrA, 'anual');
  };

  useEffect(() => {
    // Cargar username para saludo
    try { api.get('user/profile/').then(({data}) => { setUserName(data?.username || ''); }).catch(()=>{}); } catch {}
    // Al mostrar la página de renovación, bloquea definitivamente el plan básico ($7/7días)
    blockBasicForever();
    // Si hay sesión, replica el bloqueo en el backend para que aplique en otros dispositivos
    try {
      api.post('user/block-basic/', {}).catch(() => {});
      // Además, activa modo 'solo Resumen' mientras estás en renovación
      api.post('user/resumen-only/', {}).catch(() => {});
    } catch (_) {}

    const existing = document.querySelector('script[data-paypal-sdk]');
    if (!existing) {
      const s = document.createElement('script');
      s.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&vault=true&intent=subscription&components=buttons&currency=USD`;
      s.async = true;
      s.dataset.paypalSdk = '1';
      s.onload = () => { paypalLoadedRef.current = true; loadAndRender(); };
      s.onerror = () => { setErrB('No se pudo cargar PayPal'); setStatusB('error'); setErrT('No se pudo cargar PayPal'); setStatusT('error'); setErrA('No se pudo cargar PayPal'); setStatusA('error'); };
      document.head.appendChild(s);
    } else {
      paypalLoadedRef.current = true;
      loadAndRender();
    }
  }, [codeValid]);

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <header className="border-b border-gray-800">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-semibold text-white hover:opacity-90">WaveSales</Link>
          <nav className="text-sm">
            <Link to="/login" className="hover:underline">Ingresar</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-10">
        <section className="rounded-2xl border border-gray-800 bg-gray-900 p-6 mb-8 shadow-xl">
          <h1 className="text-2xl font-bold mb-3">¿A dónde fuiste? 🥺 ¡Sigue disfrutando de todo!</h1>
          <p className="mt-1">¡Hola <span className="font-semibold">{userName || 'Cliente'}</span>!</p>
          <p className="mt-2">Notamos que tu plan ha terminado... ¡y ya te extrañamos por aquí!</p>
          <p className="mt-2">¿Listo para volver a tener acceso ILIMITADO al envío de campañas masivas por solo <span className="line-through text-gray-400">$30/mes</span>?</p>
          <div className="mt-1 text-green-400 font-semibold">Ahora: $27/ mes</div>
          <p className="mt-2">Para celebrar tu regreso, ¡queremos darte un regalo! 🎉</p>
          <p className="mt-2">Actualiza en las próximas 48 horas y usa este código de bienvenida para recibir un 10% de descuento inmediato.</p>
          <div className="mt-4 p-4 rounded-xl bg-gray-800 border border-gray-700 inline-block">
            <div className="text-sm uppercase tracking-widest text-gray-300">Código</div>
            <div className="text-xl font-bold">VUELVE10</div>
          </div>
          <p className="mt-3">¡Date prisa, el reloj corre! ⏱️</p>

          {/* Mensaje específico solicitado sobre el plan de $7/7días */}
          <div className="mt-6 p-4 rounded-xl bg-gray-800 border border-gray-700">
            <div className="text-white font-semibold mb-2">Plan $7 / 7 días</div>
            <ul className="list-disc list-inside text-sm text-gray-200 space-y-1">
              <li>Leads ilimitados</li>
              <li>Automatización avanzada</li>
              <li>Soporte por email</li>
              <li>7 días</li>
              <li>$7.00 USD</li>
              <li>Plan 7 días solo ($1 x día). Total $7</li>
            </ul>
            <div className="mt-3 text-xs text-gray-400">
              Nota: Desde este momento, este plan ya no estará disponible para tu cuenta en la landing. Podrás renovar con planes superiores o desde esta página.
            </div>
          </div>

          <form onSubmit={applyCode} className="mt-6 flex flex-col sm:flex-row gap-3">
            <input value={code} onChange={(e)=>setCode(e.target.value)} placeholder="Ingresa tu código de bienvenida"
              className="px-4 py-2 rounded-lg bg-gray-800 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-cyan-500" />
            <button type="submit" className="px-5 py-2 rounded-lg bg-gradient-to-r from-cyan-500 to-blue-600 text-white hover:from-cyan-600 hover:to-blue-700">Aplicar código</button>
          </form>
          {!codeValid && (
            <div className="mt-2 text-sm text-gray-400">Ingresa el código para ver las opciones de renovación.</div>
          )}
          {codeValid && (
            <div className="mt-2 text-sm text-green-400">Código aplicado. Elige tu plan para renovar.</div>
          )}
        </section>

        {/* Planes: visibles solo con código válido */}
        {codeValid && (
          <section>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Plan Mensual */}
              <div className="rounded-2xl p-6 bg-gray-900 border border-gray-800 shadow-xl flex flex-col">
                <h3 className="text-center text-xl font-semibold">Plan Mensual</h3>
                <div className="text-center text-gray-400 line-through">$30/mes</div>
                <div className="text-center text-green-400 mb-4">Ahora: $27/ mes</div>
                <ul className="text-sm text-center space-y-2 mb-6">
                  <li>Leads ilimitados</li>
                  <li>Automatización avanzada</li>
                  <li>Soporte por email</li>
                </ul>
                <div className="mt-auto">
                  <div id={CID_BASIC} style={{ minHeight: 50 }} />
                  {statusB !== 'approved' && (
                    <div className="mt-2 text-xs text-gray-400">
                      {statusB === 'idle' && 'Preparando botón…'}
                      {statusB === 'loading' && 'Cargando PayPal…'}
                      {statusB === 'rendered' && 'Listo para suscribirte.'}
                      {statusB === 'approving' && 'Procesando suscripción…'}
                      {statusB === 'error' && <span>Error: {errB || 'Fallo inesperado'}</span>}
                    </div>
                  )}
                </div>
              </div>

              {/* Plan Trimestral */}
              <div className="rounded-2xl p-6 bg-gray-900 border border-gray-800 shadow-xl flex flex-col">
                <h3 className="text-center text-xl font-semibold">Plan Trimestral</h3>
                <div className="text-center text-gray-400 line-through">$69/trimestral</div>
                <div className="text-center text-green-400 mb-4">Ahora: $62.10/ trimestral</div>
                <ul className="text-sm text-center space-y-2 mb-6">
                  <li>Todo incluido</li>
                  <li>Automatización avanzada</li>
                  <li>Soporte 24/7</li>
                </ul>
                <div className="mt-auto">
                  <div id={CID_TRIM} style={{ minHeight: 50 }} />
                  {statusT !== 'approved' && (
                    <div className="mt-2 text-xs text-gray-400">
                      {statusT === 'idle' && 'Preparando botón…'}
                      {statusT === 'loading' && 'Cargando PayPal…'}
                      {statusT === 'rendered' && 'Listo para suscribirte.'}
                      {statusT === 'approving' && 'Procesando suscripción…'}
                      {statusT === 'error' && <span>Error: {errT || 'Fallo inesperado'}</span>}
                    </div>
                  )}
                </div>
              </div>

              {/* Plan Anual */}
              <div className="rounded-2xl p-6 bg-gray-900 border border-gray-800 shadow-xl flex flex-col">
                <h3 className="text-center text-xl font-semibold">Plan Anual</h3>
                <div className="text-center text-gray-400 line-through">$199/anual</div>
                <div className="text-center text-green-400 mb-4">Ahora: $179.10/ anual</div>
                <ul className="text-sm text-center space-y-2 mb-6">
                  <li>Todo incluido</li>
                  <li>Automatización avanzada</li>
                  <li>Soporte 24/7</li>
                </ul>
                <div className="mt-auto">
                  <div id={CID_ANUAL} style={{ minHeight: 50 }} />
                  {statusA !== 'approved' && (
                    <div className="mt-2 text-xs text-gray-400">
                      {statusA === 'idle' && 'Preparando botón…'}
                      {statusA === 'loading' && 'Cargando PayPal…'}
                      {statusA === 'rendered' && 'Listo para suscribirte.'}
                      {statusA === 'approving' && 'Procesando suscripción…'}
                      {statusA === 'error' && <span>Error: {errA || 'Fallo inesperado'}</span>}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      <footer className="border-t border-gray-800 mt-12">
        <div className="max-w-5xl mx-auto px-6 py-6 text-center text-sm text-gray-400">
          © 2025 WaveSales — Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
}
